export const ACCEPTED_LOCALES = {
  "en-GB": "en-GB",
  "it-IT": "it-IT",
  "fr-FR": "fr-FR",
  "fr-CA": "fr-FR",
  "de-DE": "de-DE",
  "de-CH": "de-DE",
  "es-ES": "es-ES",
  "es-US": "es-ES",
  "tr-TR": "tr-TR",
  "ru-RU": "ru-RU",
  "pt-PT": "pt-PT",
  "pt-BR": "pt-PT",
  "zh-CN": "zh-CN",
  "id-ID": "id-ID",
  "ja-JP": "ja-JP",
  "ko-KR": "ko-KR",
  "vi-VN": "vi-VN",
  "th-TH": "th-TH",
} as const;

export const DEFAULT_LOCALE = "en-GB" as const;
